
import {BlockEmbed} from './block';
import Quill from "../core/quill";
import Keyboard from "../modules/keyboard";
import {getPos, setPos} from "../core/selection";

class Editable extends BlockEmbed {
  static create(value) {
    const node = super.create(value);
    node.setAttribute('contenteditable', false);
    return node;
  }
  
  constructor(scroll, domNode) {
    super(scroll, domNode);
    
    this.domCursor = document.createElement('span');
    this.domCursor.classList.add('cursor_wrapper');
    this.domCursor.setAttribute('contenteditable', true);
  }
  
  attach() {
    super.attach();
  
    const quill = Quill.find(this.scroll.domNode.parentNode);
    this.quill = quill;
  
    this.domCursor.addEventListener('keydown', (e) => {
      let key = e.which || e.keyCode;
      if (key === Keyboard.keys.BACKSPACE) {
        let offset = this.offset(quill.scroll);
        quill.deleteText(offset, this.length(), Quill.sources.USER);
        quill.setSelection(offset - 1, 0, Quill.sources.USER);
        e.preventDefault();
      } else if (key === Keyboard.keys.ENTER) {
        let index = this.offset(quill.scroll) + this.length();
        quill.focus();
        quill.insertText(index, '\n', Quill.sources.USER);
        quill.setSelection(index, 0, Quill.sources.USER);
        e.preventDefault();
      }
    });
  
    this.domCursor.addEventListener('paste', (e) => {
      e.stopPropagation();
      e.preventDefault();
    });
  }
  
  attachFieldEvents(fieldContainer) {
    const quill = this.quill;
    
    fieldContainer.addEventListener('keydown', (e) => {
      let key = e.which || e.keyCode;
      let target = e.target;
      if (key === Keyboard.keys.ENTER) {
        if (e.shiftKey) {
          return;
        }
        let pos = getPos(target);
        let value = target.value;
        if (pos.start !== pos.end) {
          value = value.substr(0, pos.start) + value.substr(pos.end);
          target.value = value;
          setPos(target, {start: value.length, end: value.length});
        } else if (pos.end === value.length) {
          let index = this.offset(quill.scroll) + this.length();
          quill.focus();
          quill.insertText(index, '\n', Quill.sources.USER);
          quill.setSelection(index, 0, Quill.sources.USER);
        }
        e.preventDefault();
      }
      else if (key === Keyboard.keys.DOWN || key === Keyboard.keys.TAB || key === Keyboard.keys.RIGHT) {
        let pos = getPos(target);
        let value = target.value;
        if (pos.start === pos.end && pos.end === value.length) {
          let index = this.offset(quill.scroll) + this.length();
          quill.focus();
          quill.setSelection(index, 0, Quill.sources.USER);
          e.preventDefault();
        }
      }
      else if (key === Keyboard.keys.LEFT || key === Keyboard.keys.UP) {
        let pos = getPos(target);
        if (pos.start === pos.end && pos.start === 0) {
          let index = this.offset(quill.scroll) - 1;
          quill.focus();
          quill.setSelection(index, 0, Quill.sources.USER);
          e.preventDefault();
        }
      }
    });
  
    fieldContainer.addEventListener('paste', (e) => {
      e.stopPropagation();
    });
  
    const field = fieldContainer.querySelector('input,textarea');
    field.addEventListener('blur', (e) => {
      if (field.nodeName === 'TEXTAREA') {
        field.innerHTML = e.target.value;
      } else {
        field.value = e.target.value;
      }
    });
    
    field.style.height = '5px';
    field.style.height = (field.scrollHeight)+'px';
  }
  
  handleFocus() {
    if (!this.domNode.classList.contains('focus')) {
      let index = this.offset(this.quill.scroll);
      this.quill.focus();
      this.quill.setSelection(index, 0, Quill.sources.USER);
    }
  }
  
  update() {
    this.domCursor.innerHTML = '';
  }
  
  index() {
    return 0;
  }
  
  position() {
    return [this.domCursor, 0];
  }
  
}

export default Editable;